import React from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import {Helmet} from 'react-helmet';
import  PageHeader          from './PageHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
import { faHandHoldingHeart} from '@fortawesome/pro-light-svg-icons';
import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { faList } from '@fortawesome/pro-light-svg-icons';
import { faSmile } from '@fortawesome/pro-light-svg-icons';
import  { FooterSection }      from './FooterSection';

/* This is title section. It contains the main title for this page and a background image */

const bodySection = () =>  (
    <div className="privacy-policy-content-container">
        <div className="about-body-section">
            <div className="rc-flex-container-center-col">
                <div className="privacy-policy-title-container rc-flex-container-center-hv" >
                    <h1 className="privacy-policy-title">Privacy Policy for Pitch In Club</h1>
                </div>
                <p className="privacy-para rc-mt-3">
                    This privacy notice discloses the privacy practices for www.pitchinclub.com. 
                    This privacy notice applies solely to information collected by this website.
                </p>
                <h2 className="privacy-para rc-mt-3">Information Collection, Use, and Sharing</h2>
                <p className="privacy-para rc-mt-1">
                    In order to use this website, a user must first complete the sign up form. 
                    During registration a user is required to give information (such as name and email address). 
                    The email information is used to uniquely identify the user on the site and name is 
                    used simply to improve user experience.
                </p>
                <p className="privacy-para rc-mt-1">
                    We are the sole owners of the information collected on this site. We only have access 
                    to/collect information that you voluntarily provided via the PitchInClub application. 
                    We will not sell or rent this information to anyone
                </p>
                <p className="privacy-para rc-mt-1">
                    To improve user access, we make use of HTML 5 local storage. For instance, session 
                    information will be stored temporarily so you would not have to provide 
                    a password more than once, thereby saving time while on our site. In addition,  
                    certain commonly used reference data  may be temporarily stored to improve site performance. 
                    Both session data and reference data are deleted when you log off the application.
                </p>
                <p className="privacy-para rc-mt-1">
                    Cookies are used by Google to serve ads on our site based on user’s visits to our site or 
                    other web sites. A user can opt out of google advertising cookies by going to the ”Ads Settings” 
                    section of the google web site.
                </p>
                <p className="privacy-para rc-mt-1">
                    We may use your information to respond to you, regarding a particular reason you contacted us. 
                    We will not share your information with any third party outside of our organization.
                </p>
                <p className="privacy-para rc-mt-1">
                    Unless you ask us not to, we may contact you via email in the future to tell you about new product 
                    features or services, or changes to this privacy policy.
                </p>
               <h2 className="privacy-para rc-mt-3">Security</h2>
               <p className="privacy-para">
                    We take precautions to protect your information. When you submit sensitive information 
                    (eg. email  and password) via the website, your information is protected both online and offline.
               </p>
               <p className="privacy-para">
                    Wherever we collect sensitive information (UserID, Name, Password), that information is 
                    encrypted and transmitted to us in a secure manner. You can verify this by looking for a lock icon 
                    in the address bar and looking for "https" at the beginning of the address of the Web page.
               </p>
               <p className="privacy-para">
                    We use encryption to protect sensitive information transmitted from your browser to our server. 
                    We also store your password in encrypted form in our database. The computers/servers in which we 
                    store your information are kept in a secure environment.
               </p>
               <h2 className="privacy-para rc-mt-3">Your Access to and Control over Information</h2>
               <p className="privacy-para">
                   You may opt out of any future contacts from us at any time. You can request the following by 
                   contacting us via the <Link to="/contact-form" className="rc-link-nodecoration-light-blue" >contact</Link> form on our website:
               </p>
               <div className="privacy-list-items">
                    <ul className="privacy-para rc-mt-1">
                        <li>Have us delete your account from our website </li>
                        <li>Express any concern you have about our use of your data </li>
                    </ul>
               </div>
               <div className="rc-spacer-medium rc-mb-2">&nbsp;</div>
               
            </div>
        </div>
    </div>
)

/* This section provides list of application features */
const ctaBlock = () => (
    <div className="clp-ctablock-container">
        <div className="features-horiz-spacer4"></div>
        <h3 className="clp-cta-section-title">Remember, if you don't ask, you won't know if people are willing to Pitch In.</h3>
        <h3 className="clp-cta-section-title">Give it try. </h3>
        <div className="rc-horiz-spacer-small">&nbsp;</div>    
        <Link to="/signup" className="button features-signup-button"><p>Start Planning Now</p></Link>
        <div className="rc-horiz-spacer-small">&nbsp;</div>    
        <h3 className="clp-cta-section-subtitle">
            If you need people to volunteer some of their time, check out the 
            <Link to="/helping-hands" className="clp-cta-text-link">&nbsp;Helping Hands List</Link>
        </h3>
        <div className="rc-horiz-spacer-small">&nbsp;</div>    
        <div style={{display: "flex", justifyContent: "center"}}>
          <Link smooth to="/#cta" className="small-text-link" >Back</Link>
        </div>
    </div>
)


// Contribution List Page
export const PrivacyPolicyPage  = (props) =>  {

    return (  // use destructing to obtain function prop
        <div>
            <Helmet>
                <title>About Us - Pitch In Club</title>
                <meta name="description" content="About Us - Pitch In Club" />
            </Helmet>
            <PageHeader />
            
            {bodySection()}   
            <FooterSection />
        </div>
    );
   
}

// const mapDispatchToProps = (dispatch) => ({
//     startLogin: () => dispatch(startLogin())
// })

// export default connect(undefined, mapDispatchToProps)(LoginPage);
export default connect()(PrivacyPolicyPage);




// WEBPACK FOOTER //
// ./src/components/PrivacyPolicyPage.js